import { useEffect, useRef } from "react";
import { Box, Fab } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import Disaster from "../../Disaster";
import SearchArea from "./SearchArea";
import type { SearchAreaHandle } from "./types";

/** 暫定: 以下の disaster-id はいずれも 699 に差し替え */
const DISASTER_ID_REDIRECT_FROM_IDS = ["698","699","700","701","702","703"];
const DISASTER_ID_REDIRECT_TO = "697";

export default function SituationCheck() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const searchAreaRef = useRef<SearchAreaHandle | null>(null);

  useEffect(() => {
    const disasterId = searchParams.get("disaster-id");
    if (!disasterId || !DISASTER_ID_REDIRECT_FROM_IDS.includes(disasterId)) return;
    const next = new URLSearchParams(searchParams);
    next.set("disaster-id", DISASTER_ID_REDIRECT_TO);
    // react-router の navigate では状態が追従しないケースがあるため、フルリロードでリダイレクトする
    window.location.replace(
      `${window.location.pathname}${next.toString() ? `?${next.toString()}` : ""}`,
    );
  }, [searchParams]);

  const handleGoBack = () => {
    navigate(-1); // 前の画面に戻る
  };

  const handleBatchRegister = () => {
    if (searchAreaRef.current) {
      searchAreaRef.current.batchRegister();
    }
  };
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Box
          onClick={handleGoBack}
          sx={{
            display: "flex",
            height: "48px",
            alignItems: "center",
            paddingLeft: 5,
            fontSize: 20,
            fontWeight: "bold",
            whiteSpace: "nowrap",
            color: "primary.main",
            cursor: "pointer",
            textDecoration: "underline",
            "&:hover": {
              color: "primary.dark",
            },
            "&:active": {
              color: "primary.light",
            },
            "@media screen and (max-width:900px)": {
              paddingLeft: 2,
            },
          }}
        >
          ダッシュボード
        </Box>
        <Box
          sx={{
            display: "flex",
            height: "48px",
            alignItems: "center",
            fontSize: 20,
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
        >
          /SS被害状況確認
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "fit-content",
          justifyContent: "center",
          padding: "16px",
          borderRadius: 2,
          borderColor: "primary.main",
          boxShadow: 3,
          color: "outline.dark",
          backgroundColor: "#fff",
        }}
      >
        <Disaster />
      </Box>
      <Box>
        <SearchArea ref={searchAreaRef} />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          position: "sticky",
          bottom: "16px",
          zIndex: 3,
        }}
      >
        <Fab
          name="registerButton"
          variant="extended"
          color="primary"
          onClick={handleBatchRegister}
          sx={{
            width: "144px",
          }}
        >
          一括保存
        </Fab>
      </Box>
    </>
  );
}
